import React, { FC, useEffect, useState } from 'react'
import EmptyComponent from 'components/Empty'
import styled from 'styled-components'
import { theme, Image, Spinner } from 'ui'
import { Add } from '@material-ui/icons'
import useStore, { budgetStore } from 'store'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import { ValidatedPopulationInput } from '../Test/ValidatedInput'
import DateInputWithCalendar from '../Test/CalendarInput' 

import { Table, TableBody, TableCell, TableRow, IconButton, RadioGroup, Radio, TablePagination } from '@material-ui/core'

import { 
  SearchInput,
  StyledInputContainer,
  StyledInput,
  StyledLabel,
  StyledRequired,
  StyledSelect,
  Header,
  HeaderButtonGroup,
  HeaderTitleContainer,
  HeaderMainTitle,
  HeaderSecondTitle,
  HeaderButton,
  HeaderImageIcon,

  StatsBarContainer,
  StatsCard,
  StatsCardContainer,
  StatsTitleContainer,
  StatsTitle,
  StatsCount,
  StatsImageIcon,

  SearchBar,
  SearchBarContainer,
  FilterButton,
  FilterImageIcon,

  FilterContainer,
  FilterTitle,
  FilterRadioFormControlLabel,
  FilterRadioSelectedTitle,

  TableBar,
  TableContainerStyled,
  TableHeadStyled,
  TableCellTitle,
  TableCellCategory,
  TableCellStatus,
  TableCelllOnline,
  TableCellDescription1,
  TableCellDescription2,
  TableCellStyled,

  FilterRadioContainer,
  FilterInputContainer,
  FilterTitleContainer,
  FilterButtonApply,
  StatusItemImageIcon
} from './Protocols.styles'

import { getProtocolPermissions } from './permissions'
import CategoryModal from './CategoryModal'
import SetMainManagerModal from './SetMainManagerModal'
import ProtocolModal from './ProtocolModal'
import ProtocolViewModal from './ProtocolViewModal'
import ArchiveList from './ArchiveList'
import RemoveProtocolModal from './RemoveProtocolModal'
import ArchiveProtocolModal from './ArchiveProtocolModal'
import ProtocolEditModal from './ProtocolEditModal'
import ProtocolsSearchBar from './ProtocolsSearchBar'
import AyeIcon from 'assets/icons/ims/Aye.svg'
import SettingsIcon from 'assets/icons/ims/Settings.svg'
import BoxIcon from 'assets/icons/ims/Box.svg'
import CloseIcon from 'assets/icons/ims/Close3.svg'
import ClockIcon from 'assets/icons/ims/Clock.svg'
import EditIcon from 'assets/icons/ims/Edit.svg'
import OkIcon from 'assets/icons/ims/Ok.svg'
import DocIcon from 'assets/icons/ims/Doc.svg'
import FileIcon from 'assets/icons/ims/File.svg'
import User4Icon from 'assets/icons/ims/User4.svg'
import DeleteIcon from 'assets/icons/ims/Delete.svg'
import ZeroFilter from 'assets/icons/ims/ZeroFilter.svg'
import AyeIcon2 from 'assets/icons/protocols/icon11.svg'


const Wrap = styled.div`
  background-color:${theme.color.dialogBackground};
  @media (max-width: 768px) {
    background: rgba(0,0,0,0.05);
    padding: 1rem;
  }
  flex:1;
  padding: 1rem;
  overflow:auto;
`
const StyledIconButton = styled(IconButton)`
  padding: 8px;
`

const Protocols: FC = () => {
  const { t } = useTranslation(['budget'])
  const { members, orgs, uiStore, memberStore, user, modulesStore, protocolsStore } = useStore()
  
  const STATUS_MAP: Record<number, { title: string; color: string; bg: string }> = {
    1: { title: 'טיוטה',          color: '#4A5565', bg: '#F1F5F9' },
    2: { title: 'ממתין לאישור',   color: '#D08700', bg: '#FEF9C2' },
    3: { title: 'מאושר',          color: '#00A63E', bg: '#DCFCE7' },
    4: { title: 'נדחה',           color: '#E7000B', bg: '#FEE2E2' },
  }

  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [search, setSearch] = useState('')

  const [filterActive, setFilterActive] = useState(false)
  const [filterMode, setFilterMode] = useState('search_by_phrase')
  
  const [filterCategoryVal, setFilterCategoryVal] = useState('')
  const [filterPhraseVal, setFilterPhraseVal] = useState('')
  const [filterFromDate, setFilterFromDate] = useState<Date | null>(null)
  const [filterToDate, setFilterToDate] = useState<Date | null>(null)

  const [filterByStatus, setFilterByStatus] = useState<number>(0)
  const [viewProtocolId, setViewProtocolId] = useState<number | null>(null)
  const [openCategoryModal, setOpenCategoryModal] = useState(false)
  const [openMainManagerModal, setOpenMainManagerModal] = useState(false)
  const [openProtocolModal, setOpenProtocolModal] = useState(false)
  const [showArchive, setShowArchive] = useState(false)
  const [deleteProtocolId, setDeleteProtocolId] = useState<number | null>(null)
  const [deleteProtocolTitle, setDeleteProtocolTitle] = useState('')
  const [archiveProtocolId, setArchiveProtocolId] = useState<number | null>(null)
  const [archiveProtocolTitle, setArchiveProtocolTitle] = useState('')
  const [editProtocolId, setEditProtocolId] = useState<number | null>(null)
  const [editStatusOnly, setEditStatusOnly] = useState(false)

  const perms = getProtocolPermissions(protocolsStore.userPermissions)

  useEffect(() => {
    protocolsStore.init(orgs.currentOrgId)
  }, [])

  useEffect(() => {
    if (protocolsStore.baseUrl && protocolsStore.authToken) {
      protocolsStore.loadUserPermissions().then(res => {
        protocolsStore.loadUserList()
        protocolsStore.loadProtocols({
          pageNumber: page + 1,
          pageSize: rowsPerPage,
          ...{ filterByStatus: Number(filterByStatus)  },
          ...(filterCategoryVal ? { categoryId: Number(filterCategoryVal) } : {}),
          ...(search ? { searchText: search, searchMode: filterMode === 'search_by_phrase' ? 0 : 1 } : {}),
          ...(filterPhraseVal ? { creatorName: filterPhraseVal } : {}),
          ...(filterFromDate ? { fromDate: filterFromDate.toISOString() } : {}),
          ...(filterToDate ? { toDate: filterToDate.toISOString() } : {}),
        })

        protocolsStore.loadProtocolCounts()

        if (perms.isAdmin) {
          protocolsStore.loadCategories(orgs.currentOrgId)
        }   
      })
    }
  }, [
    page, 
    rowsPerPage, 
    search, 
    filterByStatus, 
    filterCategoryVal, 
    filterPhraseVal, 
    filterMode, 
    filterFromDate, 
    filterToDate, 
    protocolsStore.baseUrl,
    protocolsStore.authToken 
  ])

  const handleStatusCardClick = (status: int) => {
    setPage(0)
    setFilterByStatus(status) 
  }

  const getCategoryById = (categoryId: number): { color: string; bgColor: string } => {
    const categoryColors = ['#64748B', '#EC4899', '#06B6D4', '#EF4444', '#F59E0B', '#8B5CF6', '#10B981', '#3B82F6']
    const categoryBgColors = ['#F1F5F9', '#FDF2F8', '#ECFEFF', '#FEF2F2', '#FFFBEB', '#F5F3FF', '#ECFDF5', '#EFF6FF']
    const category = protocolsStore.categories.find(c => c.id === categoryId)
    const index = category ? category.colorId % categoryColors.length : 0
    return { color: categoryColors[index], bgColor: categoryBgColors[index] }
  }

  const getIconByStatus = (protocolStatusId) => {
    if (protocolStatusId == 4) return CloseIcon
    if (protocolStatusId == 1) return EditIcon
    if (protocolStatusId == 2) return ClockIcon
    if (protocolStatusId == 3) return OkIcon
    if (protocolStatusId == 0) return DocIcon
  }

  return (
    <Wrap>
        <CategoryModal open={openCategoryModal} onCloseModal={() => setOpenCategoryModal(false)}/>
        <SetMainManagerModal open={openMainManagerModal} onClose={() => setOpenMainManagerModal(false)}/>
        <ProtocolModal
          open={openProtocolModal}
          onCloseModal={() => setOpenProtocolModal(false)}
          onSaved={() => { protocolsStore.loadProtocols({ pageNumber: page + 1, pageSize: rowsPerPage, ...(filterByStatus !== null ? { filterByStatus } : {}) }); protocolsStore.loadProtocolCounts() }}
        />
        <RemoveProtocolModal
          open={deleteProtocolId !== null}
          closeModal={() => setDeleteProtocolId(null)}
          protocolId={deleteProtocolId}
          protocolTitle={deleteProtocolTitle}
          onDeleted={() => protocolsStore.loadProtocols({ pageNumber: page + 1, pageSize: rowsPerPage, ...(filterByStatus !== null ? { filterByStatus } : {}) })}
        />
        <ArchiveProtocolModal
          open={archiveProtocolId !== null}
          closeModal={() => setArchiveProtocolId(null)}
          protocolId={archiveProtocolId}
          protocolTitle={archiveProtocolTitle}
          onArchived={() => protocolsStore.loadProtocols({ pageNumber: page + 1, pageSize: rowsPerPage, ...(filterByStatus !== null ? { filterByStatus } : {}) })}
        />
        <ProtocolEditModal
          open={editProtocolId !== null}
          protocolId={editProtocolId}
          statusOnly={editStatusOnly}
          onClose={() => { setEditProtocolId(null); setEditStatusOnly(false) }}
          onSaved={() => { protocolsStore.loadProtocols({ pageNumber: page + 1, pageSize: rowsPerPage, ...(filterByStatus !== null ? { filterByStatus } : {}) }); protocolsStore.loadProtocolCounts() }}
        />
        <ProtocolViewModal
          open={viewProtocolId !== null}
          protocolId={viewProtocolId}
          onClose={() => setViewProtocolId(null)}
        />
        {showArchive ? <ArchiveList onBack={() => setShowArchive(false)} /> : <>
        <Header>
             <HeaderTitleContainer>
                <HeaderMainTitle>מערכת פרוטוקולים</HeaderMainTitle>
                <HeaderSecondTitle>ניהול, אישור והפצה של פרוטוקולים ותקנונים</HeaderSecondTitle>
            </HeaderTitleContainer>
            <HeaderButtonGroup>
               {perms.canManageMainManagers && (
                 <HeaderButton
                    color={'#0F172A'}
                    bg={'#F1F5F9'}
                    bcolor={'#E2E8F0'}
                    onClick={() => setOpenMainManagerModal(true)}
                    startIcon={<HeaderImageIcon src={User4Icon} />}
                  >
                      הגדרת מנהל ראשי
                  </HeaderButton>
               )}
                <HeaderButton
                  color={'#BB4D00'}
                  bg={'#FEF3C6'}
                  bcolor={'#FFD230'}
                  onClick={() => setShowArchive(!showArchive)}
                  startIcon={<HeaderImageIcon src={BoxIcon} />}
                >ארכיון
                </HeaderButton>
                {(perms.isAdmin || perms.isCategoryManager) && (
                  <HeaderButton
                    color={'#8200DB'}
                    bg={'#DAB2FF'}
                    bcolor={'#F3E8FF'}
                    onClick={() => setOpenCategoryModal(true)}
                    startIcon={<HeaderImageIcon src={SettingsIcon} />}
                  >
                      ניהול קטגוריות
                  </HeaderButton>
                )}
                {perms.canCreateCategory && (
                <HeaderButton
                  color={'#FFF'}
                  bg={'#6AA2FD'}
                  bcolor={'#6AA2FD'}
                  onClick={() => setOpenProtocolModal(true)}
                  startIcon={<Add/>}
                >פרוטוקול חדש</HeaderButton>)}
            </HeaderButtonGroup>
        </Header>

        <StatsBarContainer>
            {[
                { title: "נדחו", status: 4, count: protocolsStore.protocolCounts.rejectedCount, border: '#FFC9C9', selectedBorder: '#E7000B', color: '#E7000B', icon: CloseIcon },
                { title: "טיוטות", status: 1, count: protocolsStore.protocolCounts.draftCount, border: '#ebe6e7', selectedBorder: '#4A5565', color: '#4A5565', icon: EditIcon },
                { title: "ממתינים לאישור", status: 2, count: protocolsStore.protocolCounts.pendingApprovalCount, selectedBorder: '#D08700', border: '#FFF085', color: '#D08700', icon: ClockIcon },
                { title: "מאושרים", status: 3, count: protocolsStore.protocolCounts.approvedCount, selectedBorder: '#00A63E', border: '#B9F8CF', color: '#00A63E', icon: OkIcon },
                { title: "מאושרים", status: 0, count: protocolsStore.protocolCounts.totalCount, selectedBorder: '#2B7FFF', border: '#bedbff', color: '#2B7FFF', icon: DocIcon },
            ].map((item) => (
              <StatsCard border={filterByStatus === item.status ? item.selectedBorder : item.border}  selected={filterByStatus === item.status} onClick={() => handleStatusCardClick(item.status)}>
                <StatsCardContainer>
                    <StatsTitleContainer>
                        <StatsTitle>{item.title}</StatsTitle>
                        <StatsCount color={item.color}>{item.count}</StatsCount>
                    </StatsTitleContainer>
                    <StatsImageIcon src={item.icon} />
                </StatsCardContainer>
              </StatsCard>
            ))}
        </StatsBarContainer>

        <ProtocolsSearchBar
          filterActive={filterActive}
          onFilterToggle={() => setFilterActive(!filterActive)}
          onSearch={val => { setPage(0); setSearch(val) }}
        />

        {filterActive && (
            <FilterContainer>
                <FilterTitleContainer>
                <FilterTitle>אופן החיפוש</FilterTitle>
                <FilterRadioContainer>
                    <RadioGroup
                        aria-label="secommunitylect-"
                        value={filterMode}
                        onChange={(e) => setFilterMode(e.target.value)}
                        row
                    >
                        <FilterRadioFormControlLabel value="search_by_phrase" control={<Radio />} label="חיפוש לפי ביטוי מדויק" />
                        <FilterRadioFormControlLabel value="search_by_word" control={<Radio />} label="חיפוש לפי כל מילה בנפרד" />
                    </RadioGroup>
                
                </FilterRadioContainer>
                <FilterRadioSelectedTitle>{filterMode == 'search_by_phrase' ? 'יחפש את הביטוי המדויק כפי שהוזן' : 'יחפש מסמכים המכילים את אחת המילים או יותר'}</FilterRadioSelectedTitle>
                </FilterTitleContainer>

                <FilterInputContainer>
                    <StyledInputContainer>
                        <StyledLabel>סטטוס</StyledLabel>
                        <StyledSelect
                          autoFocus
                          value={`${filterByStatus}`}
                          onChange={e => { setPage(0); setFilterByStatus(parseInt(e.target.value)) }}
                        >
                          <option value='0'>הכל</option>
                          <option value='3'>מאושר</option>
                          <option value='4'>נדחה</option>
                          <option value='2'>ממתין לאישור</option>
                          <option value='1'>טיוטה</option>
                        </StyledSelect>    
                    </StyledInputContainer>

                    <StyledInputContainer>
                        <StyledLabel>קטגוריה</StyledLabel>
                        <StyledSelect
                            autoFocus
                            value={filterCategoryVal}
                            onChange={e => { setPage(0); setFilterCategoryVal(e.target.value) }}
                        >
                          <option value=''>הכל</option>
                          {protocolsStore.categories.map(c => (
                            <option key={c.id} value={String(c.id)}>{c.categoryName}</option>
                          ))}
                        </StyledSelect>    
                    </StyledInputContainer>
                </FilterInputContainer>
                <FilterInputContainer>
                    <ValidatedPopulationInput
                        id="input-id-1"
                        label="שם פרטי"
                        value={filterPhraseVal}
                        onChange={v => { setPage(0); setFilterPhraseVal(v) }}
                        placeholder="חפש לפי שם כותב המסמך..."
                        required={false}
                        error={false}
                        errorText="שדה חובה"
                        icon={null}
                    />
                </FilterInputContainer>

                <FilterInputContainer>
                    <StyledInputContainer>
                        <StyledLabel>עד תאריך</StyledLabel>
                        <DateInputWithCalendar
                            value={filterToDate}
                            onChange={date => { setPage(0); setFilterToDate(date) }}
                            locale={user.dateFnsLocal}
                        />
                    </StyledInputContainer>
                    <StyledInputContainer>
                        <StyledLabel>מתאריך</StyledLabel>
                        <DateInputWithCalendar
                            value={filterFromDate}
                            onChange={date => { setPage(0); setFilterFromDate(date) }}
                            locale={user.dateFnsLocal}
                        />
                    </StyledInputContainer>
                </FilterInputContainer>

                <FilterInputContainer> 
                  <FilterTitle style={{ cursor: 'pointer' }} onClick={() => {
                    setPage(0)
                    setFilterByStatus(0)
                    setFilterCategoryVal('')
                    setFilterPhraseVal('')
                    setFilterFromDate(null)
                    setFilterToDate(null)
                    setFilterMode('search_by_phrase')
                  }}><HeaderImageIcon src={ZeroFilter}/>&ensp;אפס סינונים</FilterTitle>
                </FilterInputContainer>
            </FilterContainer>
        )}

        <TableBar>
            <TableContainerStyled>
                <Table stickyHeader>
                    <TableHeadStyled>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell>{`כותרת`}</TableCell>
                            <TableCell>{`קטגוריה`}</TableCell>
                            <TableCell>{`תאריך`}</TableCell>
                            <TableCell>{`כותב`}</TableCell>
                            <TableCell>{`משתתפים`}</TableCell>
                            <TableCell>{`סטטוס`}</TableCell>
                             <TableCell>{`קבצים`}</TableCell>
                            <TableCell>{`צפיות`}</TableCell>
                            <TableCell>{`פעולות`}</TableCell>
                        </TableRow>
                    </TableHeadStyled>
                    <TableBody>
                        {protocolsStore.loadingProtocols && (
                            <TableRow>
                              <TableCell colSpan={9} align="center">
                                <Spinner />
                              </TableCell>
                            </TableRow>
                          )}

                          {!protocolsStore.loadingProtocols && protocolsStore.protocols.length === 0 && (
                            <TableRow>
                              <TableCell colSpan={9} align="center">
                                <EmptyComponent text="לא נמצאו פרוטוקולים"/>
                              </TableCell>
                            </TableRow>
                          )}

                          {!protocolsStore.loadingProtocols &&
                            protocolsStore.protocols.map(protocol => {
                              const status = STATUS_MAP[protocol.protocolStatusId] || { title: String(protocol.protocolStatusId), color: '#4A5565', bg: '#F1F5F9' }
                              const dateStr = protocol.protocolDate ? new Date(protocol.protocolDate).toLocaleDateString('he-IL') : ''
                              const { color, bgColor } = getCategoryById(protocol.categoryId)

                              return (
                              <TableRow key={protocol.id}>
                                <TableCellStyled>{!protocol.isRead && <TableCelllOnline/>}</TableCellStyled>
                                <TableCellStyled>
                                    <TableCellDescription1 color={!protocol.isRead ? '#1C398E' : '#101828'}>
                                        {protocol.title}
                                    </TableCellDescription1>
                                    <TableCellDescription2>{protocol.topics}</TableCellDescription2>
                                </TableCellStyled>
                                <TableCellStyled><TableCellCategory color={color} bg={bgColor}>{protocol.categoryName}</TableCellCategory></TableCellStyled>
                                <TableCellStyled><TableCellTitle>{dateStr}</TableCellTitle></TableCellStyled>
                                <TableCellStyled><TableCellTitle>{protocol.creatorName}</TableCellTitle></TableCellStyled>
                                <TableCellStyled><TableCellTitle><HeaderImageIcon src={User4Icon}/> {protocol.participantsCount}</TableCellTitle></TableCellStyled>
                                <TableCellStyled><TableCellStatus  color={status.color} bg={status.bg}><StatusItemImageIcon src={getIconByStatus(protocol.protocolStatusId)}/> {status.title}</TableCellStatus></TableCellStyled>
                                <TableCellStyled><TableCellTitle>{protocol.filesCount > 0 && <><HeaderImageIcon src={FileIcon}/> {protocol.filesCount}</>}</TableCellTitle></TableCellStyled>
                                <TableCellStyled><TableCellTitle>{protocol.viewsCount > 0 && <><HeaderImageIcon src={AyeIcon2}/> {protocol.viewsCount}</>}</TableCellTitle></TableCellStyled> 
                                <TableCell>
                                  <StyledIconButton onClick={() => { setViewProtocolId(protocol.id); protocolsStore.loadProtocolForView(protocol.id) }}><HeaderImageIcon src={AyeIcon}/></StyledIconButton>
                                  {protocol.isEditAll && <StyledIconButton onClick={() => { setEditStatusOnly(false); setEditProtocolId(protocol.id); protocolsStore.loadProtocolForEdit(protocol.id) }}><HeaderImageIcon src={EditIcon}/></StyledIconButton>}
                                  {protocol.isEditStatus && !protocol.isEditAll && <StyledIconButton onClick={() => { setEditStatusOnly(true); setEditProtocolId(protocol.id); protocolsStore.loadProtocolForEdit(protocol.id) }}><HeaderImageIcon src={OkIcon}/></StyledIconButton>}
                                  {protocol.isDelete && <StyledIconButton onClick={() => { setDeleteProtocolId(protocol.id); setDeleteProtocolTitle(protocol.title) }}><HeaderImageIcon src={DeleteIcon}/></StyledIconButton>}
                                  {protocol.isArchive && <StyledIconButton onClick={() => { setArchiveProtocolId(protocol.id); setArchiveProtocolTitle(protocol.title) }}><HeaderImageIcon src={BoxIcon}/></StyledIconButton>}
                                </TableCell>
                              </TableRow>
                            )})}
                      </TableBody>
                    </Table>
            </TableContainerStyled>
            <TablePagination
                component="div"
                count={protocolsStore.protocolsTotalCount}
                page={page}
                onPageChange={(_, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={e => {
                    setRowsPerPage(parseInt(e.target.value, 10))
                    setPage(0)
                }}
                rowsPerPageOptions={[10]}
                labelRowsPerPage="שורות בעמוד"
            />
        </TableBar>
        </>}
    </Wrap>
  )
}


export default observer(Protocols)

